/** ONIX contributor role codes — keep in sync with client/src/pages/CsvMapper & csv/types CONTRIBUTOR_ROLE_LABELS */
export const CAST_ROLE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'A01', label: 'Author' },
  { value: 'A02', label: 'Co-author' },
  { value: 'E07', label: 'Narrator' },
  { value: 'B06', label: 'Narrator (alt)' },
  { value: 'D02', label: 'Director' },
  { value: 'D03', label: 'Producer' },
  { value: 'E01', label: 'Actor' },
  { value: 'B01', label: 'Editor' },
  { value: 'A12', label: 'Illustrator' },
  { value: 'A36', label: 'Translator' },
  { value: 'A38', label: 'Original Author' },
];
